<template>
  <v-form
    @submit.prevent="onSubmit"
    :disabled="loading"
    style="max-width: 500px"
  >
    <v-row no-gutters>
      <v-col cols="12">
        <v-text-field
          :type="oldPasswordShown ? 'text' : 'password'"
          v-model="form.oldPassword"
          label="Поточний пароль"
          :append-icon="oldPasswordShown ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append="oldPasswordShown = !oldPasswordShown"
          :error-messages="oldPasswordErrors"
          @input="$v.form.oldPassword.$touch()"
          @blur="$v.form.oldPassword.$touch()"
        />
      </v-col>
      <v-col cols="12">
        <v-text-field
          :type="passwordShown ? 'text' : 'password'"
          v-model="form.password"
          label="Новий пароль"
          :append-icon="passwordShown ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append="passwordShown = !passwordShown"
          :error-messages="passwordErrors"
          @input="$v.form.password.$touch()"
          @blur="$v.form.password.$touch()"
        />
      </v-col>
      <v-col cols="12" class="pt-3">
        <v-btn type="submit" color="primary" :loading="loading">Змінити</v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { getFieldErrorMessages } from "@/helpers/errors";

export default {
  name: "ChangePasswordForm",
  mixins: [validationMixin],
  validations: {
    form: {
      oldPassword: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(64),
      },
      password: { required, minLength: minLength(8), maxLength: maxLength(64) },
    },
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      oldPasswordShown: false,
      passwordShown: false,
      form: {
        oldPassword: null,
        password: null,
      },
    };
  },
  computed: {
    oldPasswordErrors() {
      return getFieldErrorMessages(this.$v.form.oldPassword, {
        required: "Введіть поточний пароль",
        minLength: "Пароль має бути довшим або дорівнювати 8 символам",
        maxLength: "Пароль має бути коротшим або дорівнювати 64 символам",
      });
    },
    passwordErrors() {
      return getFieldErrorMessages(this.$v.form.password, {
        required: "Введіть новий пароль",
        minLength: "Пароль має бути довшим або дорівнювати 8 символам",
        maxLength: "Пароль має бути коротшим або дорівнювати 64 символам",
      });
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit("change-password", {
          oldPassword: this.form.oldPassword,
          password: this.form.password,
        });
      }
    },
  },
};
</script>
